import { InlineSelect, TextInput } from "@msuite/ui/form";
import { useTranslation } from "@msuite/ui/localization";
import type { AddUserFormSchema } from "@msuite/utils/schemas";
import { useFormContext } from "react-hook-form";
import { useRoleOptions } from "@/hooks/use-role-options";
import { useTeamPicker } from "@/hooks/use-team-picker";

export function AddUserForm() {
	/** Hooks */
	const methods = useFormContext<AddUserFormSchema>();
	const { t } = useTranslation();

	const { teams } = useTeamPicker();

	/** Query */
	// The slim read, not `useRoles`: the full list is gated on `manage Permission`,
	// which a caller delegated only `create User` does not hold — for them it would
	// 403 and leave this field with nothing to pick.
	const { roleOptions } = useRoleOptions();

	/** Render */
	return (
		<div className="v-stack gap-4">
			<div className="grid grid-cols-2 gap-4">
				<TextInput
					isRequired
					label={t("profile.first_name")}
					control={methods.control}
					name="firstName"
					placeholder={t("placeholders.first_name")}
				/>
				<TextInput
					isRequired
					label={t("profile.last_name")}
					control={methods.control}
					name="lastName"
					placeholder={t("placeholders.last_name")}
				/>
			</div>
			<TextInput
				isRequired
				label={t("personnel.fields.email")}
				control={methods.control}
				name="email"
				type="email"
				placeholder={t("placeholders.email")}
			/>
			<InlineSelect
				isRequired={false}
				label={t("organization.teams")}
				control={methods.control}
				name="teamIds"
				options={teams.map((team) => ({
					id: team.teamId,
					label: team.name,
					value: team.teamId,
				}))}
			/>
			{/* Optional: everyone receives the member base role at joining; this picker only
			    names the roles a person carries on top. */}
			<InlineSelect
				isRequired={false}
				label={t("roles.roles")}
				control={methods.control}
				name="roleIds"
				options={roleOptions.map((role) => ({
					id: role.id,
					label: role.name,
					value: role.id,
				}))}
			/>
		</div>
	);
}
